export default __webpack_public_path__ + "static/10-most-instagrammable-places-on-earth-slovenia-27b1db66af27515719bdc4dab13c1b6e.jpg";